import { PlaylistService } from "../api";
import { useQuery, type UseQueryResult } from "react-query";
import { useTypedSelector } from "../redux/store";
import { type VideoVoteResultPaginatedResult } from "../api/generated/data-contracts";

export const useGetVotedSongs = (): UseQueryResult<
  VideoVoteResultPaginatedResult,
  unknown
> => {
  const userJwt = useTypedSelector((state) => state.auth.value);

  return useQuery({
    queryKey: ["getVotedSongs", userJwt],
    queryFn: async () => {
      const response = await PlaylistService.getalluservideovotesList(
        {},
        { headers: { Authorization: `Bearer ${userJwt}` } }
      );

      return response.data;
    },
    refetchOnWindowFocus: false,
    enabled: !!userJwt
  });
};
